import { render, staticRenderFns } from "./AddPriceList.vue?vue&type=template&id=4713e256&scoped=true"
import script from "./AddPriceList.vue?vue&type=script&lang=js"
export * from "./AddPriceList.vue?vue&type=script&lang=js"
import style0 from "./AddPriceList.vue?vue&type=style&index=0&id=4713e256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713e256",
  null
  
)

export default component.exports